import React from 'react';
import './About.css';
import CEO from '../images/CEO/CEO.jpg';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <h2 className="section-title">Who Leads the Hunt?</h2>
        
        <div className="about-layout">
          <div className="about-profile">
            <div className="profile-image">
              <img src={CEO} alt="Claire Rosales, CEO of Hunter Digital Philippines" />
            </div>
            <div className="profile-info">
              <h3 className="profile-name">Claire Rosales</h3>
              <p className="profile-title">Founder, Lead Media Buyer, and Digital Marketing Specialist</p>
            </div>
          </div>
          
          <div className="about-story">
            <p className="story-text">
              The COVID-19 pandemic forced businesses to adapt to the online world. Traditional marketing, face-to-face client meetings, on-site work set-ups, and more became obsolete. For those whose lives depended on these, survival became reliant on online solutions.
            </p>
            
            <p className="story-text">
              Claire Agra-Rosales was ahead of her time. She's had hands-on experience on digital marketing back when it was still limited to social media management and email blasts. Her experience working for Global Link Events and the Presidential Communications during the ASEAN Summit honed her skills in content creation, audience engagement, and branding. Although social media management jumpstarted her career in digital marketing, it was during the pandemic when discovered a passion for media buying. When small-scale real-estate entrepreneurs struggled with low sales, Claire earned certifications for media buying and ads management in Google Ads, Meta Business Suite, and Facebook BluePrint to help their transition online. As a result, from struggling to close deals, she was able to help them close at least one to two sales per month. Her first clients did not just survive the pandemic but were also able to thrive.
            </p>
            
            <p className="story-text">
              Soon, she realized while social media raises a brand's awareness, media buying drives the sales. She wanted to practice her digital marketing skills with bigger corporations. Hence, she worked for Tupperware and helped them scale their business online through raising their brand awareness and introducing them to new market segments. When she resigned, Tupperware sought after her and her digital marketing services. From then on, Claire decided to help businesses thrive by tailoring strategies according to what the business needs. Hunter Digital Marketing Solutions was born with a mission to empower businesses of all sizes and help them keep up with the fast-paced world digital marketing through scalable online strategies.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;